module.exports = __webpack_public_path__ + "static/media/Fonts.b9691075.svg";